export const onCalculatePackageDiscountPrice = (price, discountPercent) => {
	if (discountPercent && price) {
		let discountPrice = ((100 - Number(discountPercent)) / 100) * Number(price);
		return discountPrice;
	}

	return 0;
};

export const onCalculateTakhfifanShare = (
	commission,
	price,
	discountPercent
) => {
	const discountPrice = onCalculatePackageDiscountPrice(price, discountPercent);
	return discountPrice * (commission / 100);
};

export const onCalculatePackageTaxes = (commission, price, discountPercent) => {
	const takhfifanShare = onCalculateTakhfifanShare(
		commission,
		price,
		discountPercent
	);
	return 0.09 * takhfifanShare;
};

export const onCalculateTakhfifanIncome = (
	commission,
	price,
	discountPercent
) => {
	const takhfifanShare = onCalculateTakhfifanShare(
		commission,
		price,
		discountPercent
	);
	const tax = onCalculatePackageTaxes(commission, price, discountPercent);
	const result = Math.round(takhfifanShare + tax);
	const factor = result ? -1 : 1;
	return factor * result;
};

export const onCalculateMerchantIncome = (
	commission,
	price,
	discountPercent,
	discountPrice = undefined
) => {
	const PackagediscountPrice =
		discountPrice || onCalculatePackageDiscountPrice(price, discountPercent);
	const merchantShare = PackagediscountPrice * ((100 - commission) / 100);
	const tax = onCalculatePackageTaxes(commission, price, discountPercent);
	return Math.round(merchantShare - tax);
};
